<!-- Header -->
<header class="app-header">
  <div class="header-inner">
    <!-- Brand -->
    <a routerLink="/" class="brand" (click)="closeMobileMenu()">
      <img src="logo-mark.svg" alt="Quick Indexing Tool" class="brand-mark" />
      <span class="brand-name">Quick Indexing</span>
    </a>

    <!-- Desktop Nav -->
    <nav class="nav-desktop">
      <a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
      <a routerLink="/pricing" class="nav-link" routerLinkActive="active">Pricing</a>
      <a routerLink="/blog" class="nav-link" routerLinkActive="active">Blog</a>
      <a routerLink="/api-docs" class="nav-link" routerLinkActive="active">API</a>

      <ng-container *ngIf="isLoggedIn">
        <span class="nav-divider"></span>
        <a routerLink="/dashboard" class="nav-link" routerLinkActive="active">Dashboard</a>
        <a routerLink="/submit" class="nav-link" routerLinkActive="active">Submit</a>
        <a routerLink="/history" class="nav-link" routerLinkActive="active">History</a>
      </ng-container>
    </nav>

    <!-- Right Section -->
    <div class="header-actions">
      <ng-container *ngIf="isLoggedIn; else loggedOut">
        <a routerLink="/pricing" class="credits-pill" title="Your credits">
          <span class="credits-dot"></span>
          <span class="credits-value">{{ userCredits }}</span>
          <span class="credits-label">credits</span>
        </a>
        <div class="user-menu" (click)="$event.stopPropagation()">
          <button class="user-trigger" (click)="toggleUserMenu($event)">
            <span class="user-avatar">{{ userInitials }}</span>
          </button>
          <div class="user-dropdown" *ngIf="userMenuOpen">
            <div class="user-dropdown-header">
              <div class="user-avatar-lg">{{ userInitials }}</div>
              <div class="user-dropdown-info">
                <span class="user-dropdown-name">{{ userName }}</span>
                <span class="user-dropdown-credits">{{ userCredits }} credits available</span>
              </div>
            </div>
            <div class="user-dropdown-divider"></div>
            <a routerLink="/dashboard" class="user-dropdown-item" (click)="userMenuOpen = false">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
              Dashboard
            </a>
            <a routerLink="/submit" class="user-dropdown-item" (click)="userMenuOpen = false">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Submit URLs
            </a>
            <a routerLink="/history" class="user-dropdown-item" (click)="userMenuOpen = false">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              History
            </a>
            <a routerLink="/pricing" class="user-dropdown-item" (click)="userMenuOpen = false">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
              Buy Credits
            </a>
            <div class="user-dropdown-divider"></div>
            <button class="user-dropdown-item user-dropdown-logout" (click)="logout()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
              Sign Out
            </button>
          </div>
        </div>
      </ng-container>

      <ng-template #loggedOut>
        <a routerLink="/login" class="btn btn-ghost btn-sm">Sign in</a>
        <a routerLink="/login" class="btn btn-primary btn-sm">Get started</a>
      </ng-template>

      <!-- Mobile toggle -->
      <button class="mobile-toggle" (click)="toggleMobileMenu()" [class.active]="mobileMenuOpen" aria-label="Toggle menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </div>

  <!-- Mobile Nav -->
  <div class="nav-mobile" [class.open]="mobileMenuOpen">
    <div class="nav-mobile-inner">
      <a routerLink="/" class="mobile-link" (click)="closeMobileMenu()">Home</a>
      <a routerLink="/pricing" class="mobile-link" (click)="closeMobileMenu()">Pricing</a>
      <a routerLink="/blog" class="mobile-link" (click)="closeMobileMenu()">Blog</a>
      <a routerLink="/api-docs" class="mobile-link" (click)="closeMobileMenu()">API</a>

      <ng-container *ngIf="isLoggedIn">
        <div class="mobile-divider"></div>
        <a routerLink="/dashboard" class="mobile-link" (click)="closeMobileMenu()">Dashboard</a>
        <a routerLink="/submit" class="mobile-link" (click)="closeMobileMenu()">Submit URLs</a>
        <a routerLink="/history" class="mobile-link" (click)="closeMobileMenu()">History</a>
        <button class="mobile-link mobile-logout" (click)="logout(); closeMobileMenu()">Sign Out</button>
      </ng-container>

      <ng-container *ngIf="!isLoggedIn">
        <div class="mobile-divider"></div>
        <a routerLink="/login" class="btn btn-secondary" (click)="closeMobileMenu()">Sign in</a>
        <a routerLink="/login" class="btn btn-primary" (click)="closeMobileMenu()">Get started</a>
      </ng-container>
    </div>
  </div>
</header>

<!-- Main Content -->
<main id="main-content" class="main-content" role="main">
  <router-outlet></router-outlet>
</main>

<!-- Footer -->
<footer class="app-footer">
  <div class="container">
    <div class="footer-grid">
      <!-- Brand Column -->
      <div class="footer-brand">
        <a routerLink="/" class="brand">
          <img src="logo-mark.svg" alt="Quick Indexing Tool" class="brand-mark" />
          <span class="brand-name">Quick Indexing</span>
        </a>
        <p class="footer-tagline">Submit URLs. Deploy crawlers. Get indexed in minutes.</p>
        <div class="footer-status">
          <span class="status-dot live"></span>
          <span>All systems operational</span>
        </div>
      </div>

      <!-- Product -->
      <div class="footer-col">
        <h6 class="footer-heading">Product</h6>
        <a routerLink="/pricing" class="footer-link">Pricing</a>
        <a routerLink="/submit" class="footer-link">Submit URLs</a>
        <a routerLink="/drip-guide" class="footer-link">Drip Mode</a>
        <a routerLink="/api-docs" class="footer-link">Developer API</a>
        <a routerLink="/faq" class="footer-link">FAQ</a>
      </div>

      <!-- Resources -->
      <div class="footer-col">
        <h6 class="footer-heading">Resources</h6>
        <a routerLink="/blog" class="footer-link">Blog</a>
        <a routerLink="/help" class="footer-link">Help Center</a>
        <a routerLink="/contact-us" class="footer-link">Contact</a>
      </div>

      <!-- Legal -->
      <div class="footer-col">
        <h6 class="footer-heading">Legal</h6>
        <a routerLink="/privacy-policy" class="footer-link">Privacy Policy</a>
        <a routerLink="/terms-conditions" class="footer-link">Terms of Service</a>
        <a routerLink="/refunds-policy" class="footer-link">Refund Policy</a>
      </div>
    </div>

    <div class="footer-bottom">
      <p class="footer-copyright">&copy; 2026 Quick Indexing Tool. All rights reserved.</p>
      <p class="footer-support">support&#64;quickindexingtool.com</p>
    </div>
  </div>
</footer>

<!-- Loading Overlay -->
<div class="loading-overlay" *ngIf="isLoading">
  <div class="spinner spinner-lg"></div>
  <p>Processing...</p>
</div>
